var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5.05396H3.5C3.03587 5.05396 2.59075 5.23833 2.26256 5.56652C1.93437 5.89471 1.75 6.33983 1.75 6.80396V20.804C1.75 21.2681 1.93437 21.7132 2.26256 22.0414C2.59075 22.3696 3.03587 22.554 3.5 22.554H24.5C24.9641 22.554 25.4092 22.3696 25.7374 22.0414C26.0656 21.7132 26.25 21.2681 26.25 20.804V6.80396C26.25 6.33983 26.0656 5.89471 25.7374 5.56652C25.4092 5.23833 24.9641 5.05396 24.5 5.05396ZM22.575 6.80396L14 12.7365L5.425 6.80396H22.575ZM3.5 20.804V7.6002L13.5013 14.5215C13.6477 14.6231 13.8217 14.6775 14 14.6775C14.1783 14.6775 14.3523 14.6231 14.4987 14.5215L24.5 7.6002V20.804H3.5Z",
    fill: "#101F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a6ef4d30d90e7a0981d6c7e375f6031.svg";
export { ForwardRef as ReactComponent };